import React from 'react';
import { LOCATION_ORIGIN } from '../../../call-api';
import nfibFooterHtml from './nfibFooterHtmlString';
import { getNfibPublicThemeCssUrl, getMontserratFontsCssUrl } from './navConfig';
import {
  NFIB_PUBLIC_SITE_ORIGIN,
  rewriteNfibPublicSiteUrlsInHtml,
} from './nfibPublicSite';
import { rewriteProductionEngageHostToOrigin } from './engageEnvLinks';
import './nfibSiteChrome.css';

function removeFooterJoinNowCta(shadowRoot) {
  if (!shadowRoot) {
    return;
  }
  shadowRoot.querySelectorAll('a[href*="join-now"]').forEach(a => {
    a.remove();
  });
}

export default class NfibComFooter extends React.Component {
  constructor(props) {
    super(props);
    this.hostNode = null;
    this._formCleanup = null;
    this._isMounted = false;
    this.setHostRef = this.setHostRef.bind(this);
  }

  setHostRef(el) {
    this.hostNode = el;
  }

  componentDidMount() {
    this._isMounted = true;
    this.mountShadow();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.teardownFormBinding();
    const el = this.hostNode;
    if (el && el.shadowRoot) {
      el.shadowRoot.innerHTML = '';
    }
  }

  teardownFormBinding() {
    if (this._formCleanup) {
      this._formCleanup();
      this._formCleanup = null;
    }
  }

  getBundledHtml() {
    let raw =
      typeof nfibFooterHtml === 'string'
        ? nfibFooterHtml
        : nfibFooterHtml.default || '';
    const year = new Date().getFullYear();
    raw = raw.replace(/__COPYRIGHT_YEAR__/g, String(year));
    raw = rewriteNfibPublicSiteUrlsInHtml(raw);
    return raw;
  }

  bindNewsletterForm(shadowRoot) {
    this.teardownFormBinding();
    const form = shadowRoot.getElementById('nfib-newsletters');
    if (!form) {
      return;
    }
    const onSubmit = e => {
      e.preventDefault();
      window.open(`${NFIB_PUBLIC_SITE_ORIGIN}/`, '_blank', 'noopener,noreferrer');
    };
    form.addEventListener('submit', onSubmit);
    this._formCleanup = () => form.removeEventListener('submit', onSubmit);
  }

  mountShadow() {
    const el = this.hostNode;
    if (!el || !this._isMounted) {
      return;
    }

    this.teardownFormBinding();

    let shadow = el.shadowRoot;
    if (!shadow) {
      shadow = el.attachShadow({ mode: 'open' });
    } else {
      shadow.innerHTML = '';
    }

    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = getMontserratFontsCssUrl();

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = getNfibPublicThemeCssUrl();

    const hostStyle = document.createElement('style');
    hostStyle.textContent = `
      :host {
        display: block;
        width: 100%;
      }
    `;

    const legalStyle = document.createElement('style');
    legalStyle.textContent = `
      /* Black legal strip: explicit type so it matches nfib.com when theme tokens target charcoal footer */
      .nfib-legal-bar {
        font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }
      .nfib-legal-bar .nfib-legal-text {
        margin: 0;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
        letter-spacing: 0;
        color: #ffffff;
      }
      .nfib-legal-bar .nfib-legal-copyright {
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.92);
      }
    `;

    const wrap = document.createElement('div');
    wrap.innerHTML = this.getBundledHtml().trim();

    shadow.appendChild(fontLink);
    shadow.appendChild(link);
    shadow.appendChild(hostStyle);
    while (wrap.firstChild) {
      shadow.appendChild(wrap.firstChild);
    }
    shadow.appendChild(legalStyle);

    rewriteProductionEngageHostToOrigin(shadow, LOCATION_ORIGIN);

    this.bindNewsletterForm(shadow);
    removeFooterJoinNowCta(shadow);
  }

  render() {
    return (
      <div ref={this.setHostRef} className="nfib-public-footer-host" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/NfibSiteChrome/NfibComFooter.js